import { useTranslations } from 'next-intl';
import { useRef, useEffect } from 'react';

import { useGTMReadCards } from '@/fo/api/gtm';

import { useFilterSyncContext } from '../../hooks/FilterSyncContext';
import { Question, SortType } from '../../types';
import { QuestionCard } from '../QuestionCard/QuestionCard';
import { ShowMoreButton } from '../ShowMoreButton/ShowMoreButton';
import { SortPanel } from '../SortPanel/SortPanel';

import { styles } from './QuestionsList.styles';

export interface QuestionsListProps {
  questions: Question[];
  sortType: SortType | null;
  onSortTypeChange: (sortType: SortType | null) => void;
  onLoadMore: () => void;
  isShowLoadMore?: boolean;
  isLoading?: boolean;
}

export function QuestionsList({
  questions,
  sortType,
  onSortTypeChange,
  onLoadMore,
  isShowLoadMore = false,
  isLoading = false
}: QuestionsListProps) {
  const slots = styles();
  const t = useTranslations();
  const gtmRef = useGTMReadCards('read_question', 'view_all', questions.length);

  const filterRef = useRef<HTMLDivElement>(null);
  const { setContentFilterRef } = useFilterSyncContext();

  useEffect(() => {
    if (filterRef.current) {
      setContentFilterRef(filterRef.current);
    }
  }, [setContentFilterRef]);

  return (
    <div className={slots.base()}>
      <div ref={filterRef}>
        <SortPanel
          sortType={sortType}
          onSortTypeChange={onSortTypeChange}
        />
      </div>
      <div
        ref={gtmRef}
        className={slots.list()}
      >
        {questions.map((question) => (
          <QuestionCard
            key={question.id}
            question={question}
          />
        ))}
      </div>

      {isShowLoadMore && (
        <ShowMoreButton
          onClick={onLoadMore}
          isLoading={isLoading}
        >
          {t('review.buttons.questionsShowMore')}
        </ShowMoreButton>
      )}
    </div>
  );
}
